import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { queryIdTree } from '@/api/api';
import pick from 'lodash.pick';
import { getAction } from '@/api/manage';
export default {
  name: 'PostModal',
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '岗位表单',
      departId: '',
      departTreeData: [],
      tableName: 'sys_post',
      labelCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 19
        }
      },
      form_fields: ['departId', 'code', 'name', 'category', 'status', 'job', 'remark', 'sort'],
      form_fields_time: [],
      postTypeList: [],
      validatorRules: {
        departId: {
          rules: [{
            required: true,
            message: '请输入部门id!'
          }]
        },
        code: {
          rules: [{
            required: true,
            message: '请输入编号!'
          }]
        },
        name: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请选择状态!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请选择岗位类型!'
          }]
        },
        sort: {
          rules: [{
            required: true,
            message: '请输入排序!'
          }]
        }
      },
      url: {
        postType: '/sys/post/type',
        add: '/sys/post',
        edit: '/sys/post'
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);

      if (this.model.id == null) {
        this.model.departId = this.departId;
      }

      this.loadDepartTree();
      this.loadPostTypeList();
      this.visible = true;
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    loadPostTypeList: function loadPostTypeList() {
      var _this2 = this;

      var param = {
        pageNo: 1,
        pageSize: 99999
      };
      getAction(this.url.postType, param).then(function (res) {
        if (res.success) {
          _this2.postTypeList = res.result.records;
        }
      });
    },
    loadDepartTree: function loadDepartTree() {
      var that = this;
      queryIdTree().then(function (res) {
        if (res.success) {
          that.departTreeData = res.result;
        }
      });
    }
  }
};